import { isEmpty } from "lodash";
import React from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import Rapid7InsightCloudCredentialsForm from "./Rapid7InsightCloudCredentialsForm";
import Rapid7InsightCloudMappingForm from "./Rapid7InsightCloudMappingForm";

const Rapid7InsightCloudConfligListing = (props) => {
  const extraColumns = [
    {
      dataIndex: "type",
      title: "Integration Type",
      render: (type, { cloudAccountName }) =>
        !isEmpty(cloudAccountName) ? "Cloud Account" : "Application",
      width: 200,
    },
    {
      dataIndex: "cloudAccountName",
      title: "Cloud Account",
      render: columnRenderArrayData,
      width: 200,
    },
    {
      dataIndex: "application",
      title: "Application",
      render: columnRenderArrayData,
      width: 200,
    },
  ];

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={Rapid7InsightCloudMappingForm}
      extraColumns={extraColumns}
      CredentialsForm={Rapid7InsightCloudCredentialsForm}
    />
  );
};

export default Rapid7InsightCloudConfligListing;
